import { render } from "./positionmodal.vue?vue&type=template&id=e06a0516"
import script from "./positionmodal.vue?vue&type=script&lang=js"
export * from "./positionmodal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__